import {
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useCallback, useEffect } from "react";
import { useUserRights } from "../../../contexts/UserRightsContext";
import axios from "axios";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  label: {
    fontSize: 12,
  },
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  button: {
    margin: theme.spacing(1),
  },
  // Se conservan tus estilos originales; sin agregar border
  center: {
    margin: "0 auto",
    textAlign: "center",
    width: "100%",
    "& .MuiTextField-root": {
      width: 200,
    },
    "& .MuiFormGroup-row": {
      justifyContent: "center",
    },
    "& .MuiFormControl-root": {
      justifyContent: "center",
    },
  },
  centerFS: {
    margin: "0 auto",
    textAlign: "center",
    width: "100%",
    "& .MuiTextField-root": {
      width: 200,
    },
    "& .MuiFormGroup-row": {
      justifyContent: "center",
    },
    "& .MuiFormControl-root": {
      justifyContent: "center",
    },
  },
}));

export default function ProfileInfo(props) {
  const player = props.player || {};
  const classes = useStyles();
  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  // Usamos directamente props.Player y la función updatePlayerField
  const handleChange = (event, key) => {
    props.updatePlayerField(key, event.target.value);
  };

  const handleCheckbox = (event, key) => {
    props.updatePlayerField(key, event.target.checked);
  };

  const handlePasswordChange = (event) => {
    props.updatePlayerField("password", event.target.value);
  };

  const Player_UpdatePassword = () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const PlayerResetPasswordReqDTO = {
      IdPlayer: props.Player.idPlayer,
      Password: props.Player.password,
      IdUser: userInfo.userId,
    };
    axios
      .post(
        process.env.REACT_APP_API2_URL + "/Player/Player_UpdatePassword",
        PlayerResetPasswordReqDTO
      )
      .then((response) => {
        if (response.data === 0) {
          toast.success("Password Successfully Updated");
          if (props.requestPlayerInfo) {
            props.requestPlayerInfo();
          }
        } else {
          toast.error("An error has occurred. Try again.");
        }
      });
  };

  const changePlayer = useCallback(
    (event) => {
      if (event.key === "Enter" || event.keyCode === 13) {
        props.ChangeUser(event.target.value);
      }
    },
    [props]
  );

  const BULK_FIELDS = ["Master", "Status", "OnlineAccess"];

  const [indet, setIndet] = React.useState({});

  useEffect(() => {
    if (props.isBulk) {
      const init = {};
      BULK_FIELDS.forEach(f => { init[f] = true; });
      setIndet(init);
    } else {
      setIndet({});
    }
  }, [props.isBulk]);

  const handleCheck = (field) => {
    if (indet?.[field]) {
      setIndet(prev => ({ ...prev, [field]: false }));
    }
  };

  const isIndeterminate = (field) => !!(props.isBulk && indet?.[field]);


  if (!props.Player) return <></>;

  return (
    <React.Fragment>
      <br />
      <h2 className="w-full text-center">{props.Player.player}</h2>
      <form className={`${classes.center} grid grid-cols-3 w-full gap-4`}>
        {/* Columna 1: Account y Code */}
        <div className="vertical-options vertical-height">
          <TextField
            size="small"
            type="text"
            label="Account"
            value={props.Player.player || ""}
            onChange={(event) => handleChange(event, "player")}
            disabled={props.Player.idPlayer !== 0 || props.isBulk}
            variant="outlined"
          />
          <TextField
            size="small"
            type="text"
            label="Code"
            value={props.Player.password || ""}
            onChange={handlePasswordChange}
            variant="outlined"
          />
          {props.Player.idPlayer !== 0 && (
            <Button
              hidden={!hasRights(486, 500)}
              variant="contained"
              onClick={Player_UpdatePassword}
            >
              Reset Password
            </Button>
          )}
        </div>
        {/* Columna 2: Name y Apellidos */}
        <div className="vertical-options vertical-height">
          <TextField
            className="w-full"
            size="small"
            type="text"
            label="Name"
            value={props.Player.name || ""}
            onChange={(event) => handleChange(event, "name")}
            variant="outlined"
          />
          <TextField
            className="w-full"
            size="small"
            type="text"
            label="First Lastname"
            value={props.Player.lastName || ""}
            onChange={(event) => handleChange(event, "lastName")}
            variant="outlined"
          />
          <TextField
            className="w-full"
            size="small"
            type="text"
            label="Second Lastname"
            value={props.Player.lastName2 || ""}
            onChange={(event) => handleChange(event, "lastName2")}
            variant="outlined"
          />
        </div>
        {/* Columna 3: Flags y Checkboxes */}
        <div className="vertical-options vertical-height">
          <FormControlLabel
            classes={{ label: classes.label }}
            control={
              <Checkbox
                size="small"
                checked={props.Player.master || false}
                indeterminate={isIndeterminate("Master")}
                onChange={(event) => { handleCheckbox(event, "master"); handleCheck("Master") }}
                color="primary"
              />
            }
            label="Master"
          />
          <FormControlLabel
            classes={{ label: classes.label }}
            control={
              <Checkbox
                size="small"
                checked={props.Player.status === "E"}
                indeterminate={isIndeterminate("Status")}
                onChange={(event) => {
                  props.updatePlayerField("status", event.target.checked ? "E" : "D");
                  handleCheck("Status")
                }
                }
                color="primary"
              />
            }
            label="Enabled"
          />
          <FormControlLabel
            classes={{ label: classes.label }}
            control={
              <Checkbox
                size="small"
                checked={props.Player.onlineAccess || false}
                indeterminate={isIndeterminate("OnlineAccess")}
                onChange={(event) => { handleCheckbox(event, "onlineAccess"); handleCheck("OnlineAccess") }}
                color="primary"
              />
            }
            label="Online Access"
          />
        </div>
      </form>
    </React.Fragment>
  );
}